'use client'

import React from 'react'
import type { MediaBlock as MediaBlockProps } from '@/payload-types'
import { MediaBlock as MediaComponent } from '@/components/MediaBlock'

export const MediaBlock: React.FC<MediaBlockProps> = (props) => {
  const transformedProps = {
    media: props.media,
    caption: props.caption || undefined,
    maxWidth: props.maxWidth ? Number(props.maxWidth) : undefined,
    maxHeight: props.maxHeight ? Number(props.maxHeight) : undefined,
    className: props.className || undefined,
    imgClassName: props.imgClassName || undefined,
    flat: props.flat || undefined,
  }
  
  return <MediaComponent {...transformedProps} />
}
